<template>
  <div>
    <b-container>
      <b-row>
        <b-col md="12" sm="12" lg="12" xs="12" xl="8" class="text-left">
          <h1>
            Lejárt a munkamenete. <br />
            Kérjük jelentkezzen be újra!
          </h1>
          <div class="mt-5">
            <b-row cols="2">
              <b-col>
                <b-button @click="goToLogin" class="w-100" variant="primary">Bejelentkezés</b-button>
              </b-col>
              <b-col>
                <b-button @click="goToHome" class="w-100">Főoldal</b-button>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col md="12" sm="12" lg="12" xs="12" xl="4">
          <session-timeout-svg></session-timeout-svg>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import SessionTimeoutSvg from '@/components/svg/SessionTimeout'

export default {
  name: 'SessionExpired',
  components: {
    SessionTimeoutSvg
  },
  mounted() {
    this.$store.dispatch('logout')
  },
  methods: {
    goToHome() {
      this.$router.push('/')
    },
    goToLogin() {
      this.$router.push('/login')
    }
  }
}
</script>

<style></style>
